module.exports = __webpack_public_path__ + "img/logo-white.a7b9e101.png";